import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";

export const enable2FA = async () => {
  try {
    const response = await axios.post("/api/auth/2fa-manage", {
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      data: {
        sharedKey: response.data.sharedKey,
        recoveryCodesLeft: response.data.recoveryCodesLeft,
        isTwoFactorEnabled: response.data.isTwoFactorEnabled,
        isMachineRemembered: response.data.isMachineRemembered,
      },
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
};

export const enable2FALogin = async (email?: string, companyId?: number) => {
  try {
    const response = await axios.post("/api/auth/2fa-anonymous-manage", {
      email,
      companyId,
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      data: {
        sharedKey: response.data.sharedKey,
        recoveryCodesLeft: response.data.recoveryCodesLeft,
        isTwoFactorEnabled: response.data.isTwoFactorEnabled,
        isMachineRemembered: response.data.isMachineRemembered,
      },
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
};

export const enable2FAAccount = async (twoFactorCode: string) => {
  try {
    const response = await axios.post(
      "/api/auth/2fa-manage",
      {
        enable: true,
        twoFactorCode: twoFactorCode,
        resetSharedKey: false,
        resetRecoveryCodes: true,
        forgetMachine: true,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      data: {
        sharedKey: response.data.sharedKey,
        recoveryCodesLeft: response.data.recoveryCodesLeft,
        recoveryCodes: response.data.recoveryCodes,
        isTwoFactorEnabled: response.data.isTwoFactorEnabled,
        isMachineRemembered: response.data.isMachineRemembered,
      },
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
};

export const enable2FAAccountLogin = async (
  email: string,
  twoFactorCode: string,
  companyId: number,
) => {
  try {
    const response = await axios.post(
      "/api/auth/2fa-anonymous-manage",
      {
        email,
        enable: true,
        twoFactorCode: twoFactorCode,
        resetSharedKey: false,
        resetRecoveryCodes: true,
        forgetMachine: true,
        companyId,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      data: {
        sharedKey: response.data.sharedKey,
        recoveryCodesLeft: response.data.recoveryCodesLeft,
        recoveryCodes: response.data.recoveryCodes,
        isTwoFactorEnabled: response.data.isTwoFactorEnabled,
        isMachineRemembered: response.data.isMachineRemembered,
      },
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
};

export const disable2FA = async () => {
  try {
    await axios.post(
      "/api/auth/2fa-manage",
      {
        enable: false,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
};

export async function downloadUsersToChangePassword() {
  try {
    const response = await axios.get(
      "/api/auth/change-password-by-administrator/users",
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function disableAccountLocks(email: string) {
  try {
    const response = await axios.post(
      "/api/auth/disable-account-locks",
      {
        email,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      message: response.data.message || t("Account locks disabled"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function downloadSubmittingComments(
  from: string,
  to: string,
  pageNumber: number,
) {
  try {
    const response = await axios.get("/api/submitting-comments", {
      params: {
        from,
        to,
        pageNumber,
      },
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}
